import { store } from "../stores/Store";
import en from "../translations/en";
import lt from "../translations/lt";
import de from "../translations/de";
var lang = {en, lt, de};


export function __(str, obj = null){
    if(obj){
        return obj[store.langCode][str];
    }
    if(lang[store.langCode]){
        return lang[store.langCode][str];
    }
    
    return  lang['en'][str];;
}
export function __t(obj){
    if(obj){
        return obj[store.langCode];
    }
    return '';
}